import { CurrencyLimitData } from '../typings/constants';
import { ConstantsCurrencyQueryFragment } from '../typings/graphql-grid';

export function constantMapper(item: ConstantsCurrencyQueryFragment): CurrencyLimitData {
    return {
        minDailyBudget: Number(item.minDailyBudget),
        maxDailyBudget: Number(item.maxDailyBudget),
        bigRate: Number(item.bigRate),
        minPrice: Number(item.minPrice),
        maxPrice: Number(item.maxPrice),
        defaultPrice: Number(item.defaultPrice),
        minCpmPrice: Number(item.minCpmPrice),
        maxCpmPrice: Number(item.maxCpmPrice),
        autobudgetAvgCpaWarning: Number(item.autobudgetAvgCpaWarning),
        autobudgetAvgPriceWarning: Number(item.autobudgetAvgPriceWarning),
        autobudgetClicksBundleWarning: Number(item.autobudgetClicksBundleWarning),
        autobudgetMaxPriceWarning: Number(item.autobudgetMaxPriceWarning),
        autobudgetSumWarning: Number(item.autobudgetSumWarning),
        maxAutobudget: Number(item.maxAutobudget),
        maxAutobudgetBid: Number(item.maxAutobudgetBid),
        maxAutobudgetClicksBundle: Number(item.maxAutobudgetClicksBundle),
        minAutobudget: Number(item.minAutobudget),
        minAutobudgetBid: Number(item.minAutobudgetBid),
        minAutobudgetClicksBundle: Number(item.minAutobudgetClicksBundle),
        minAutobudgetAvgCpa: Number(item.minAutobudgetAvgCpa),
        minAutobudgetAvgPrice: Number(item.minAutobudgetAvgPrice),
        brandSurveyBudgetThreshold: Number(item.brandSurveyBudgetThreshold),
        autobudgetPayForConversionAvgCpaWarning: Number(item.autobudgetPayForConversionAvgCpaWarning)
    };
}
